module.exports = __webpack_public_path__ + "img/logo.2146d12e.png";